import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleLeftMenu, changeSidebarType } from '../../store/layout/actions';
import { isSubscriber as isSubscriberSelector } from '../../selectors/auth';
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu';

import logo from '../../assets/images/logo-sm-light.png';
import logoLightPng from '../../assets/images/logo-light.png';
import logoDark from '../../assets/images/logo-dark.png';

const Header = () => {
  const { leftMenu, leftSideBarType } = useSelector((state) => state.Layout);
  const isSubscriber = useSelector(isSubscriberSelector);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const dispatch = useDispatch();

  const toggleFullscreen = () => {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen)
        document.documentElement.requestFullscreen();
      else if (document.documentElement.mozRequestFullScreen)
        document.documentElement.mozRequestFullScreen();
      else if (document.documentElement.webkitRequestFullscreen)
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT,
        );
    } else {
      if (document.cancelFullScreen) document.cancelFullScreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitCancelFullScreen)
        document.webkitCancelFullScreen();
    }
  };

  const tToggle = () => {
    dispatch(toggleLeftMenu(!leftMenu));
    if (leftSideBarType === 'default')
      dispatch(changeSidebarType('condensed', isMobile));
    else if (leftSideBarType === 'condensed')
      dispatch(changeSidebarType('default', isMobile));
  };

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="32" />
                </span>
                <span className="logo-lg">
                  <img src={logoLightPng} alt="" height="32" />
                </span>
              </Link>
            </div>

            {!isSubscriber && (
              <button
                type="button"
                onClick={tToggle}
                className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                id="vertical-menu-btn">
                <i className="fa fa-fw fa-bars"></i>
              </button>
            )}

            {isSubscriber && isMobile && (
              <Link to="/" className="d-flex align-items-center">
                <img
                  src={require('../../assets/images/logo-dark.png')}
                  alt="SOS Dottore"
                  className="navigation__logo"
                />
              </Link>
            )}
          </div>

          <div className="d-flex">
            {process.env.REACT_APP_ENVIRONMENT === 'dev' && (
              <div className="align-self-center mr-3">
                <span className="badge badge-danger font-size-14">DEV</span>
              </div>
            )}
            {!isMobile && (
              <div className="dropdown d-none d-lg-inline-block ml-1">
                <button
                  type="button"
                  onClick={toggleFullscreen}
                  className="btn header-item noti-icon waves-effect"
                  data-toggle="fullscreen">
                  <i className="bx bx-fullscreen"></i>
                </button>
              </div>
            )}

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
